import { render } from "./ModalModificaPrenotazione.vue?vue&type=template&id=b5244e8a&scoped=true"
import script from "./ModalModificaPrenotazione.vue?vue&type=script&lang=js"
export * from "./ModalModificaPrenotazione.vue?vue&type=script&lang=js"

import "./ModalModificaPrenotazione.vue?vue&type=style&index=0&id=b5244e8a&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5244e8a"]])

export default __exports__